import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HelpScoreForm from "./screens/Helpscore/HelpScoreForm";
import CalculateHelpScore from "./screens/Helpscore/CalculateHelpScore";
import Contact from "./screens/Contact/Contact";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import AdminDashboard from "./screens/AdminDashboard/AdminDashboard";
import Login from "./screens/Login/Login";

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<HelpScoreForm />} />
      <Route path="/calculateHelpScore" element={<CalculateHelpScore />} />
      <Route exact path="/contact" element={<Contact />} />
      <Route exact path="/login" element={<Login />} />

      <Route
        path="/admin/*"
        element={
          <ProtectedRoute admin>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Router>
);

export default App;
